// please note, this is also defined in css (/scss/base/_breakpoints.scss) and should ideally be the same

export var breakpointWidthMD = 992; 
export var breakpointWidth = 1024;